import { Fueling } from './fueling';

export class FuelingMergeBase {
  eventAt: string;
  eventAtSource: number;
  eventAtSourceId: number;
  driverName: string;
  driverNameSource: number;
  driverNameSourceId: number;
  fuelChangeLiters: number;
  fuelChangeLitersSource: number;
  fuelChangeLitersSourceId: number;
  positionDescription: string;
  positionLongitude: number;
  positionLatitude: number;
  positionSource: number;
  positionSourceId: number;
  note: string;
}
